import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Container,
  Typography,
  Button,
  Stack,
  Box,
  TextField,
  IconButton,

} from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import UploadIcon from '@mui/icons-material/Upload';
import DeleteIcon from '@mui/icons-material/Delete';
import PublishIcon from '@mui/icons-material/Publish';
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import BASE_URL from '../config';
const UploadVideo = () => {
  const [events, setEvents] = useState([]);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [videoSelection, setVideoSelection] = useState({});
  const [newEventName, setNewEventName] = useState("");
  //const [videosToUpload, setVideosToUpload] = useState([]);
  const [selectedVideos, setSelectedVideos] = useState(null);
  const fetchEvents = async () => {
    console.log(BASE_URL);
    const response = await axios.get(`${BASE_URL}/api/events`);
    setEvents(response.data);
  };

  const handleEventSelection = (event) => {
    if (currentEvent && currentEvent.event_id === event.event_id) {
      // If the event is already selected, set currentEvent to null to hide the videos
      setCurrentEvent(null);
    } else {
      setCurrentEvent(event);
      setCurrentVideoIndex(0); // Reset to the first video
    }
  };

  const handleVideoNavigation = (direction) => {
    if (!currentEvent) return;

    const videoCount = currentEvent.videos.length;
    if (direction === "next" && currentVideoIndex < videoCount - 1) {
      setCurrentVideoIndex(currentVideoIndex + 1);
    } else if (direction === "prev" && currentVideoIndex > 0) {
      setCurrentVideoIndex(currentVideoIndex - 1);
    }
  };

  const toggleVideoSelection = (videoName) => {
    setVideoSelection((prev) => ({
      ...prev,
      [videoName]: !prev[videoName],
    }));
  };

  const deleteSelectedVideos = async () => {
    if (!currentEvent) return;

    const selectedVideoNames = Object.keys(videoSelection).filter(
      (videoName) => videoSelection[videoName]
    );
    if (selectedVideoNames.length === 0) {
      alert("Please select videos to delete.");
      return;
    }

    await axios.post(
      `${BASE_URL}/api/events/${currentEvent.event_id}/delete-videos`,
      { video_names: selectedVideoNames }
    );
    alert("Selected videos deleted successfully");
    setVideoSelection({});
    fetchEvents();
  };
  const addEvent = async () => {
    if (!newEventName.trim()) {
      alert("Event name cannot be empty.");
      return;
    }

    const response = await axios.get(
      `${BASE_URL}/api/events/check?event_name=${newEventName}`
    );
    if (response.data) {
      alert("Event already exists. Please choose a different name.");
      return;
    }

    await axios.post(`${BASE_URL}/api/events`, {
      event_name: newEventName,
    });
    alert("Event added successfully!");
    setNewEventName("");
    fetchEvents();
  };

  const deleteEvent = async (eventId) => {
    if (
      window.confirm(
        "Are you sure you want to delete this event? All associated videos will be deleted."
      )
    ) {
      await axios.delete(`${BASE_URL}/api/events/${eventId}`);
      alert("Event and its videos deleted successfully.");
      fetchEvents();
      if (currentEvent?.event_id === eventId) {
        setCurrentEvent(null);
      }
    }
  };
  // Upload videos for the event
  /* const handleVideoUpload = async (eventId) => {
    if (videosToUpload.length === 0) {
      alert("Please select videos to upload.");
      return;
    }

    const formData = new FormData();
    videosToUpload.forEach((video) => formData.append("videos", video));

    await axios.post(`${BASE_URL}/api/events/${eventId}/videos`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    alert("Videos uploaded successfully!");
    fetchEvents(); // Refresh events list after upload
    setVideosToUpload([]); // Reset uploaded videos list
  }; */
  const handleVideoUpload = async (eventId) => {
    if (!selectedVideos) {
        alert('Please select videos to upload.');
        return;
    }
    const formData = new FormData();
    Array.from(selectedVideos).forEach(file => formData.append('videos', file));
    await axios.post(`${BASE_URL}/api/events/${eventId}/videos`, formData);
    alert('Videos uploaded successfully');
    fetchEvents();
};
  // Handle file input change (multiple files)
  /* const handleFileChange = (e) => {
    setVideosToUpload(e.target.files);
  }; */

  useEffect(() => {
    fetchEvents();
  }, []);

  const shareWhatsApp = (event) => {
    const message = `Check out this newly added Event: ${event.event_name}\nhttps://siddharthedu.in/#/video-gallery/${event.event_id}`;
    const isMobile = /iPhone|iPad|iPod|Android|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const whatsappURL = isMobile
    ? `whatsapp://send?text=${encodeURIComponent(message)}`
    : `https://web.whatsapp.com/send?text=${encodeURIComponent(message)}`;

  window.open(whatsappURL, "_blank");
  };

  return (
    <Container>
    <Typography variant="h4" align="center" sx={{ my: 4 }}>
      Event Video Management
    </Typography>
    <Stack direction="row" spacing={2} mb={3}>
      <TextField
        label="New Event Name"
        value={newEventName}
        onChange={(e) => setNewEventName(e.target.value)}
        fullWidth
      />
      <Button variant="contained" onClick={addEvent}>
        Add Event
      </Button>
    </Stack>
    <Stack spacing={2}>
      {events.map((event) => (
        <Box
          key={event.event_id}
          //sx={{ display: "flex", justifyContent: "space-between" }}
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          {/* Event name and actions */}
      <Stack direction="row" spacing={2} justifyContent="space-between">
          <Button
            variant="contained"
            onClick={() => handleEventSelection(event)}
          >
            {event.event_name}
          </Button>
          <Button
                                        variant="contained"
                                        component="label"
                                        startIcon={<UploadIcon />}
                                    >
                                        Upload
                                        <input
                                            hidden
                                            multiple
                                            type="file"
                                            onChange={(e) => setSelectedVideos(e.target.files)}
                                        />
                                    </Button>
                                    <Button
                                     variant="contained"
                                     color="primary"
                                     startIcon={<PublishIcon />}
                                    onClick={() => handleVideoUpload(event.event_id)}>Submit</Button>
          <Button
            variant="contained"
            color="error"
            startIcon={<DeleteIcon />}
            onClick={() => deleteEvent(event.event_id)}
          >
            Delete
          </Button>
          <IconButton
                  onClick={() => shareWhatsApp(event)}
                  color="success"
                >
                  <WhatsAppIcon />
                </IconButton>
          </Stack>
          {/* Render videos only for the selected event */}
      {currentEvent?.event_id === event.event_id && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="h5">{currentEvent.event_name}</Typography>

          {currentEvent.videos.length > 0 ? (
            <Box>
              <video
                src={`${BASE_URL}/uploads/videos/${currentEvent.event_id}/${currentEvent.videos[currentVideoIndex]}`}
                controls
                style={{
                  width: "100%",
                  maxHeight: "400px",
                  marginBottom: "16px",
                }}
              />
              <Stack direction="row" spacing={2} justifyContent="center">
                <Button
                  onClick={() => handleVideoNavigation("prev")}
                  disabled={currentVideoIndex === 0}
                >
                  Previous
                </Button>
                <Button
                  onClick={() =>
                    toggleVideoSelection(currentEvent.videos[currentVideoIndex])
                  }
                >
                  {videoSelection[currentEvent.videos[currentVideoIndex]]
                    ? "Unselect"
                    : "Select for Deletion"}
                </Button>
                <Button
                  onClick={() => handleVideoNavigation("next")}
                  disabled={
                    currentVideoIndex === currentEvent.videos.length - 1
                  }
                >
                  Next
                </Button>
              </Stack>
              <Stack direction="row" justifyContent="center" mt={2}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={deleteSelectedVideos}
                >
                  Delete Selected Videos
                </Button>
              </Stack>
            </Box>
          ) : (
            <Typography>No videos found for this event.</Typography>
          )}
        </Box>
 )}
        </Box>
      ))}
    </Stack>
{/* <Stack>
    {currentEvent && (
      <Box sx={{ mt: 4 }}>
        <Typography variant="h5">{currentEvent.event_name}</Typography>
       

        {currentEvent.videos.length > 0 ? (
          <Box>
            <video
              src={`${BASE_URL}/uploads/videos/${currentEvent.event_id}/${currentEvent.videos[currentVideoIndex]}`}
              controls
              style={{
                width: "100%",
                maxHeight: "400px",
                marginBottom: "16px",
              }}
            />
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button
                onClick={() => handleVideoNavigation("prev")}
                disabled={currentVideoIndex === 0}
              >
                Previous
              </Button>
              <Button
                onClick={() =>
                  toggleVideoSelection(currentEvent.videos[currentVideoIndex])
                }
              >
                {videoSelection[currentEvent.videos[currentVideoIndex]]
                  ? "Unselect"
                  : "Select for Deletion"}
              </Button>
              <Button
                onClick={() => handleVideoNavigation("next")}
                disabled={currentVideoIndex === currentEvent.videos.length - 1}
              >
                Next
              </Button>
            </Stack>
            <Stack direction="row" justifyContent="center" mt={2}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={deleteSelectedVideos}
                >
                  Delete Selected Videos
                </Button>
              </Stack>
          </Box>
        ) : (
          <Typography>No videos found for this event.</Typography>
        )}
      </Box>
      
    )}
    </Stack> */}
  </Container>
  );
};

export default UploadVideo;
